import { Component, DestroyRef, inject, type OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';

import { AuthenticationService } from '@app/auth/services/authentication.service';
import { StorageService } from '@app/shared/services/storage.service';
import { WindowService } from '@app/shared/services/window.service';

@Component({
    selector: 'cor-sso-login',
    templateUrl: './sso-login.component.html',
    imports: [RouterModule],
})
export class SSOLoginComponent implements OnInit {
    private readonly authService = inject(AuthenticationService);
    private readonly storage = inject(StorageService);
    private readonly windowService = inject(WindowService);
    private readonly destroyRef = inject(DestroyRef);

    protected readonly message = signal('Processing ...');

    ngOnInit() {
        this.message.set('Please wait - Authentication in progress');
        this.authService
            .refreshToken()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: response => {
                    this.message.set('Please wait - Login in progress');
                    this.authService.saveTokens(response);
                    this.authService
                        .fetchAndStoreUserDetails()
                        .pipe(takeUntilDestroyed(this.destroyRef))
                        .subscribe(() => {
                            this.message.set('Please wait - Login complete. Redirecting ...');
                            // NOTE: We do a window.location.href instead of router.navigate because we need
                            //       application to be recreated with a authenticated /meta.json
                            const returnUrl =
                                this.storage.getSessionStorage('returnUrl') || '/home';
                            this.windowService.replaceUrl(returnUrl);
                            this.storage.clearKeyFromSessionStorage('returnUrl');
                        });
                },
                error: () => {
                    this.message.set('Login failed');
                },
            });
    }
}
